import { render } from "./customConfig.vue?vue&type=template&id=a766069e"
import script from "./customConfig.vue?vue&type=script&lang=js"
export * from "./customConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__